import { render, staticRenderFns } from "./NavigationBottom.vue?vue&type=template&id=8c7eb5c2&scoped=true&"
import script from "./NavigationBottom.vue?vue&type=script&lang=ts&"
export * from "./NavigationBottom.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationBottom.vue?vue&type=style&index=0&id=8c7eb5c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7eb5c2",
  null
  
)

export default component.exports